module.exports = __webpack_public_path__ + "img/APPR.94c48fe0.svg";